<template>
  <div>
    <!-- 专门针对企业id=19（亳州农业谷）显示的界面（小马物联网和陈杰做的水肥） -->
    <template v-if="currentEnterprise === 19">
      <bozhou></bozhou>
    </template>
    <el-card v-else style="min-heigh: 500px">
      <!-- 非亳州农业谷则显示正常内容 -->
      <!-- 页面标题，卡片头 -->
      <div slot="header" class="clearfix">
        <span>环境监控</span>
        <el-radio-group v-model="park" size="small" style="float: right">
          <el-radio-button
            v-for="park in parks"
            :label="park.id"
            :key="park.id"
          >
            {{ park.name }}
          </el-radio-button>
        </el-radio-group>
      </div>
      <!-- 页面主体内容 -->
      <el-row>
        <div>
          <el-row
            style="
              border-bottom: 1px solid #b1b1b1;
              margin-bottom: 15px;
              padding-bottom: 20px;
            "
          >
            <el-col :span="4" style="margin-top: 5px; font-size: 13px">
              <i class="el-icon-map-location"></i>
              园区环境
            </el-col>
            <el-col :span="18">
              <el-row
                :gutter="2"
                style="
                  display: flex;
                  justify-content: space-between;
                  margin-top: 5px;
                "
              >
                <el-col>
                  <span class="park-env-lbl"> 空气湿度:</span>
                  <span class="park-env-val">{{ outdoorDatas.airh }}</span>
                  <span class="park-env-unit">%RH</span>
                </el-col>
                <el-col>
                  <span class="park-env-lbl">空气温度:</span>
                  <span class="park-env-val"> {{ outdoorDatas.airt }}</span>
                  <span class="park-env-unit">°C</span>
                </el-col>
                <el-col>
                  <span class="park-env-lbl">大气压:</span>
                  <span class="park-env-val">{{ outdoorDatas.airp }}</span>
                  <span class="park-env-unit">hPa</span>
                </el-col>
                <el-col>
                  <span class="park-env-lbl">光照强度:</span>
                  <span class="park-env-val">{{ outdoorDatas.illu }}</span>
                  <span class="park-env-unit">Lux</span>
                </el-col>
                <el-col>
                  <span class="park-env-lbl">风向:</span>
                  <span class="park-env-val">
                    {{ outdoorDatas.windd | windTxt }}
                  </span>
                </el-col>
                <el-col>
                  <span class="park-env-lbl">风速:</span
                  ><span class="park-env-val">{{ outdoorDatas.winds }}</span>
                  <span class="park-env-unit">m/s</span>
                </el-col>
              </el-row>
            </el-col>
          </el-row>
        </div>
      </el-row>
      <el-row :gutter="20">
        <!-- 左侧地块选项 -->
        <el-col :span="4">
          <el-table
            ref="landSelector"
            :data="lands"
            highlight-current-row
            :show-header="false"
            @current-change="landSelected"
          >
            <el-table-column prop="name"></el-table-column>
          </el-table>
        </el-col>

        <!-- 右侧页面主体内容 -->
        <el-col v-show="lands.length != 0" :span="20">
          <monitor-of-doctor
            v-if="landId == 31"
            :land-id="landId"
            :irrigate-sn="irrigateSn"
          />

          <monitor-of-land
            v-if="landId != 31"
            :land-id="landId"
            :irrigate-sn="irrigateSn"
            stype="margin-top:10px"
          />
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import bozhou from './bozhou.vue'

import { parkSearch } from '@/api/park.js'
import { getAreaData } from '@/api/land.js'
import { getDevicesByParkId } from '@/api/equip.js'
import MonitorOfLand from './MonitorOfLand.vue'
import MonitorOfDoctor from './MonitorOfDoctor.vue'
import { searchUrl, getEquipData } from '@/api/equipControl.js'
export default {
  name: 'EvironmentMonitor',
  components: { MonitorOfLand, MonitorOfDoctor, bozhou },
  data() {
    return {
      /**
       * 当前选中的园区id
       */
      park: undefined,
      /**
       * 当前企业下辖的园区信息列表
       */
      parks: [],
      /**
       * 当前选中园区内地块列表
       */
      lands: [],
      irrigateSn: undefined,
      /**
       * 室外气象设备sn
       */
      outdoorSn: undefined,
      /**
       * 室外气象数据，键值对
       */
      outdoorDatas: {},
      landId: undefined,
      outdoorDatasUrl: null,
    }
  },
  computed: {
    /**
     * 当前企业
     */
    currentEnterprise() {
      return this.$store.getters.currentEnterprise.id
    },
  },
  watch: {
    /**
     * 监测当前园区，如果发生变化，则刷新地块、园区气象等信息
     */
    park: function (parkId) {
      if (parkId !== undefined) {
        // 清除此前的园区气象数据显示
        Object.keys(this.outdoorDatas).forEach((item) => {
          this.outdoorDatas[item] = ''
        })
        // 初始化地块列表
        this.refreshLands()
        // 获取园区采控设备信息
        this.getParkDevicesAndDatas()
      }
    },
  },
  filters: {
    /**
     * 风向数值转文字的过滤器
     */
    windTxt(val) {
      return ['北', '东北', '东', '东南', '南', '西南', '西', '西北'][val]
    },
  },
  mounted() {
    // 初始化园区列表，把列表中首个园区设置为当前园区
    parkSearch({
      enterpriseId: this.currentEnterprise,
    }).then((resp) => {
      this.parks = resp.data.list
      this.park = this.parks[0].id
    })
  },
  beforeDestroy() {
    console.log('【↓↓↓】', this.$options.name)
  },
  methods: {
    /**
     * 获取园区气象设备信息，如果有设备的话，顺便确定其对应的物联网微服务域名，以及获取数据（实际应该轮询获取）
     * */
    getParkDevicesAndDatas() {
      getDevicesByParkId(this.park).then((resp) => {
        const { data } = resp
        console.log('park devices = ', data)
        let obj = data.find((item) => item.deviceType == 'meteo')
        let obj1 = data.find((item) => item.deviceType == 'irrigate')

        this.outdoorSn = obj ? obj.sn : undefined
        this.irrigateSn = obj1 ? obj1.sn : undefined
        console.log('本部园区为', data)

        //特殊处理，本部园区水肥配置为1，嵌入绿智鑫农业科技水肥控制界面
        if (data[0].parkId == 3) {
          this.irrigateSn = 1
          console.log('水肥配置为', this.irrigateSn)
        }

        if (!this.outdoorSn) {
          // 如果园区没有气象设备的sn信息，则清除数据显示
          this.outdoorDatas = {}
        } else {
          // 如果园区有气象设备的sn，则根据sn，查询其所在物联网平台的domain，查到后马上读取数据
          searchUrl(this.outdoorSn).then((res) => {
            const { domain } = res.data
            this.outdoorDatasUrl =
              'http://' + domain + '/api/realtime/' + this.outdoorSn
            this.getOutdoorDatas()
          })
        }
      })
    },
    /**
     * 读取室外气象数据
     */
    getOutdoorDatas() {
      getEquipData(this.outdoorDatasUrl).then((res) => {
        if (res.data.deviceData) {
          this.outdoorDatas = res.data.deviceData
        } else {
          Object.keys(this.equips).forEach((item) => {
            this.outdoorDatas[item] = ''
          })
        }
      })
    },
    /**
     * 某个地块被选中
     */
    landSelected(row) {
      this.landId = row.id
    },
    /**
     * 根据当前园区，刷新地块列表（在园区初始化或切换时调用），并默认选中第一个地块
     */
    refreshLands() {
      getAreaData({
        enterpriseId: this.currentEnterprise.id,
        parkId: this.park,
      }).then((resp) => {
        this.lands = resp.data.list

        if (resp.data.list.length == 0) {
          return
        }
        if (this.lands.length != 0) {
          this.$refs.landSelector.setCurrentRow(this.lands[0])
          this.landId = this.lands[0].id
        }
      })
    },
  },
}
</script>
<style scoped>
.park-env-lbl {
  font-size: 11px;
  color: #666;
}
.park-env-val {
  font-size: 14px;
}
.park-env-unit {
  font-size: 10px;
  color: #909090;
}
</style>



// WEBPACK FOOTER //
// src/components/monitor/environment/Index.vue